<template lang="pug">
	div
		//
			.row(v-if="resumen && resumenSemana")
				.col(v-if="resumenSemana")
					.card.mt-2
						.card-header.bg-info.text-white
							span.fa.fa-search.mr-2
							b Detalles de esta semana
						.card-body
							.row
								.col.text-center
									div
										span.fa.fa-briefcase
									b Jornada total
									br
									| {{resumenSemana.Jornada | hora}}
								.col.text-center
									div
										span.fa.fa-briefcase
									b Trabajado
									br
									| {{resumenSemana.Total | hora}}
								.col.text-center
									div
										span.fa.fa-briefcase
									b Falta justificada
									br
									| {{resumenSemana.Falta | hora}}
								.col.text-center
									div
										span.fa.fa-briefcase
									b
										span(v-if="resumenSemana.SinTrabajar < 0") Pendientes
										span(v-else) Extras
									br
									| {{resumenSemana.SinTrabajar | hora}}
								.col.text-center
									div
										span.fa.fa-hourglass
									b Nocturnas
									br
									| {{resumenSemana.Nocturna | hora}}
								.col.text-center
									div
										span.fa.fa-hourglass-end
									b Festivas
									br
									| {{resumenSemana.Festivo | hora}}
								.col.text-center
									div
										span.fa.fa-hourglass-end
									b Debes
									br
									| {{resumenSemana.Deuda | hora}}
								.col.text-center
									div
										span.fa.fa-hourglass-end
									b Te deben
									br
									| {{resumenSemana.Acumulados | hora}}
								
				.col(v-if="resumen")
					.card.mt-2
						.card-header
							span.fa.fa-filter.mr-2
							b Estadísticas del intérvalo buscado
						.card-body
							.row
								.col.text-center
									div
										span.fa.fa-briefcase
									b Jornada total
									br
									| {{resumen.Jornada | hora}}
								.col.text-center
									div
										span.fa.fa-briefcase
									b Trabajado
									br
									| {{resumen.Total | hora}}
								.col.text-center
									div
										span.fa.fa-briefcase
									b
										span(v-if="resumen.SinTrabajar < 0") Pendientes
										span(v-else) Extras
									br
									| {{resumen.SinTrabajar | hora}}
								.col.text-center
									div
										span.fa.fa-hourglass
									b Acumulado
									span.fa.fa-info-circle.ml-2.text-info(title="Cálculo basado en el intérvalo de fechas dado")
									br
									| {{resumen.Acumulados | hora}}
								.col.text-center
									div
										span.fa.fa-hourglass-end
									b Consumido
									span.fa.fa-info-circle.ml-2.text-info(title="Cálculo basado en el intérvalo de fechas dado")
									br
									| {{resumen.Consumidos | hora}}
								.col.text-center(:class="resumen.Acumulados - resumen.Consumidos < 0 ? 'text-danger' : 'text-success'")
									div
										span.fa.fa-hourglass-start
									b Pendiente por consumir
									br
									span {{resumen.Acumulados - resumen.Consumidos | hora}}
		div.mt-3.card
			.card-header.bg-dark.text-white
				.row
					.col.text-left
						span.fa.fa-list.mr-2
						| Resultados
			table.table.table-striped.m-0
				thead
					tr
						th Dia
						th Empleado
						th Registros
						th Horas
						th Tipos de hora
				tbody
					tr(
						v-for="registro in agrupados"
						:key="registro.RegistroID"
						:class="getClase(registro)"
					)
						td {{registro.Dia}}
						td
							div {{registro.UsuarioNombre}}
						td
							div.registroHora(v-for="reg in registro.registros" :key="reg.RegistroID")
								div {{reg.FechaInicioJornada | moment('HH:mm:ss')}}
								div -
								div {{reg.FechaFinJornada | moment('HH:mm:ss')}}
								
							div(v-if="registro.FechaFinJornada && registro.FechaFinJornada - registro.FechaInicioJornada > 43200", title="Jornada de 12 horas o más")
								b
									span.fa.fa-exclamation-triangle.mr-2
									| INCIDENCIA
						td
							span {{registro.Total | hora}}
						td
							div.desglose(v-if="registro.desgloses.length > 0")
								div(v-for="(d, di) in registro.desgloses", :key="di")
									span.nombre {{d.TipoJornada}}
									span.total {{d.Total | hora}}
									span.acumulado(v-if="d.Acumulado > 0") {{d.Acumulado | hora}}
									span.acumulado(v-else-if="d.Acumulado < 0") -{{d.Acumulado * -1 | hora}}
						td.text-right
						//
							div(v-if="registro.FechaFinJornada && registro.Naturaleza !== 'Vacaciones'")
								button.m-2.btn.btn-sm.btn-warning(@click="verDetalle = registro.RegistroID")
									span.fa.fa-eye
								button.m-2.btn.btn-sm.btn-primary(v-if="permiteEditar(registro)", @click="editar = registro.RegistroID")
									span.fa.fa-edit
								span.m-2(v-else)
									span.fa.fa-lock
							div(v-else-if="registro.Naturaleza !== 'Vacaciones'")
								button.btn.btn-warning.btn-sm(@click="fichando = true")
									span.fa.fa-address-card.mr-2
									| Fichar salida

					tr(
						v-if="!registros || registros.length === 0"
					)
						td.p-3.text-center(colspan="8")
							h3.text-danger
								span.fa.fa-info-circle(style="font-size:3em;")
								br
								| No hay registros
		Editor(v-if="editar", :RegistroID="editar", @cerrar="cerrarEditor()")
		// Fichar(v-if="fichando" @cerrar="fichando = false")
		Detalle(v-if="verDetalle", :RegistroID="verDetalle", @cerrar="verDetalle = null")
</template>

<script>
import { mapGetters } from 'vuex'
import Editor from '../editor/editor'
import Fichar from '../editor/fichar'
import Detalle from './detalles'
export default {
	props: ['registros', 'resumen', 'resumenSemana'],
	components: {
		Editor,
		Detalle,
		Fichar
	},
	data () {
		return {
			verDetalle: null,
			editar: null,
			fichando: false
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		}),
		agrupados () {
			// Agrupamos por día y usuario
			const resultados = this.registros.reduce((mapa, registro) => {
				const RegistroID = registro.RegistroID
				const UsuarioID = registro.UsuarioID
				const dia = this.$moment(registro.FechaInicioJornada * 1000).format('DD-MM-YYYY')
				const clave = UsuarioID + '-' + dia
				let total = registro.Tiempo
				let horasTotal = Math.floor(total / 3600)
				total = total % 3600
				let minutosTotal = Math.floor(total / 60)
				total = total % 60
				let segundosTotal = total
				horasTotal = horasTotal < 10 ? 0 + '' + horasTotal : horasTotal
				minutosTotal = minutosTotal < 10 ? 0 + '' + minutosTotal : minutosTotal
				segundosTotal = segundosTotal < 10 ? 0 + '' + segundosTotal : segundosTotal
				const totalStr = horasTotal + ':' + minutosTotal + ':' + segundosTotal

				total = registro.Acumulado
				let horasAcumulado = Math.floor(total / 3600)
				total = total % 3600
				let minutosAcumulado = Math.floor(total / 60)
				total = total % 60
				let segundosAcumulado = total
				let acumuladoStr = ''
				if (horasAcumulado !== 0 || minutosAcumulado !== 0 || segundosAcumulado !== 0) {
					horasAcumulado = horasAcumulado < 10 ? 0 + '' + horasAcumulado : horasAcumulado
					minutosAcumulado = minutosAcumulado < 10 ? 0 + '' + minutosAcumulado : minutosAcumulado
					segundosAcumulado = segundosAcumulado < 10 ? 0 + '' + segundosAcumulado : segundosAcumulado
					acumuladoStr = horasAcumulado + ':' + minutosAcumulado + ':' + segundosAcumulado
				}

				const regi = {
					RegistroID: RegistroID,
					FechaInicioJornada: registro.FechaInicioJornada,
					FechaFinJornada: registro.FechaFinJornada,
					FechaRegistroEntrada: registro.FechaRegistroEntrada,
					FechaRegistroSalida: registro.FechaRegistroSalida,
					Total: registro.Total,
					Bloqueado: registro.Bloqueado,
					DuracionStr: this.$moment.utc(registro.Total).format('H:mm:ss'),
					UsuarioNombre: registro.UsuarioNombre,
					Naturaleza: registro.Naturaleza,
					UsuarioID: registro.UsuarioID,
					IPLocalEntrada: registro.IPLocalEntrada,
					IPLocalSalida: registro.IPLocalSalida,
					LatitudEntrada: registro.LatitudEntrada,
					LatitudSalida: registro.LatitudSalida,
					LongitudEntrada: registro.LongitudEntrada,
					LongitudSalida: registro.LongitudSalida
				}
				const desglose = {
					TipoJornada: registro.TipoJornada,
					Total: registro.Tiempo,
					TotalStr: totalStr,
					Acumulado: registro.Acumulado,
					AcumuladoStr: acumuladoStr
				}

				if (!mapa.has(clave)) {
					mapa.set(clave, {
						Dia: dia,
						UsuarioNombre: registro.UsuarioNombre,
						Total: registro.Tiempo,
						registros: [regi],
						desgloses: [desglose]
					})
				} else {
					const reg = mapa.get(clave)
					reg.Total = reg.Total + registro.Tiempo
					reg.registros.push(regi)
					reg.desgloses.push(desglose)
					reg.registros.sort((a, b) => {
						if (a.FechaInicioJornada <= b.FechaInicioJornada) {
							return -1
						} else {
							return 1
						}
					})
					mapa.set(clave, reg)
				}
				return mapa
			}, new Map())
			return Array.from(resultados).map(r => r[1])
		},
		dias () {
			if (!this.registros) {
				return 0
			}

			let anterior = null
			return this.registros.reduce((dias, registro) => {
				const fecha = new Date(registro.FechaInicioJornada * 1000)
				if (fecha.getDate() !== anterior) {
					dias = dias + 1
					anterior = fecha.getDate()
				}
				return dias
			}, 0)
		},
		resultados () {
			if (!this.registros) {
				return []
			}

			return this.registros.map(reg => {
				if (reg.FechaInicioJornada && reg.FechaFinJornada) {
					let dif = reg.FechaFinJornada - reg.FechaInicioJornada
					let horas, minutos
					horas = Math.floor(dif / 3600) + 'h '
					dif = dif % 3600
					minutos = Math.floor(dif / 60) + 'm '
					dif = dif % 60
					reg.Duracion = horas + minutos + dif + 's'
				} else {
					reg.Duracion = ''
				}

				return reg
			})
		}
	},
	methods: {
		getClase (registro) {
			const clase = []
			if (!registro.Tiempo < 3600 * 8 * 1000) {
				clase.push('abierto')
			} else {
				clase.push('incidencia')
				return 'incidencia'
			}

			return ''
		},
		cerrarEditor () {
			this.editar = null
			this.$emit('buscar')
		},
		permiteEditar (registro) {
			if (this.usuario.ID !== registro.UsuarioID && !this.permisos.gestion_jornada_editarTodos) {
				return false
			}

			if (!registro.FechaRegistroSalida) {
				return false
			}

			return (registro.Bloqueado === null)
		}
	}
}
</script>

<style scoped>
.registroHora {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
}

.registroHora > div:first-child {
	padding-right: 5px;
}

.registroHora > div:last-child {
	padding-left: 5px;
}
.Vacaciones {
	color: orangered;
}

.Falta {
	color: darkred;
}

.Libre {
	color: green;
}

.desglose {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.desglose > div > .nombre {
	color: orange;
	font-weight: bold;
	margin-right: 10px;
}

.desglose > div > .total {
	color: black;
	margin-right: 10px;
}

.desglose > div > .acumulado {
	color: darkgreen;
	margin-right: 10px;
}

tr.abierto {
	background-color: #C82333 !important;
	color: white !important;
}

tr.incidencia {
	background-color: #fcc490 !important;
	color: black !important;
}

span.jornadaActiva {
	animation: parpadeo 1s linear infinite;
	color: white !important;
}

@keyframes parpadeo {
  50% {
    opacity: 0.3;
  }
}

</style>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/listados/resultados-dias.vue